var moment = require('moment');
var localForage = require('localforage');
export default {
    install: function (Vue) {
        const helpers = {
            /**
             * Ritorna l'elemento dell'oggetto in base alla chiave.
             * La chiave può avere un subelemento
             * @param obj
             * @param key
             * @returns {*}
             */
            // TODO: Da migliorare.
            getObjectData(obj, key, typ) {
                if (key == 'now') {
                    let nowDate = moment().format('DD/MM/YYYY');
                    if (obj['updated_at'] && obj['updated_at'] != null && obj['updated_at'] != "") {
                        nowDate = moment(obj['updated_at']).format('DD/MM/YYYY');
                    }
                    return nowDate;
                }
                // TODO: Na merda del genere, ma va bene così
                if (key == 'sede.indirizzo' || key == 'sede.luogo') {
                    if(obj.sede == null || obj.sede == '') {
                        if(obj.customer && obj.customer.sedi) {
                            return obj.customer.sedi[key.replace('sede.', '')]
                        } else {
                            return "";
                        }
                    } else {
                        try {
                            let s = null;
                            if (typeof obj.sede === 'string' || obj.sede instanceof String) {
                                s = JSON.parse(obj.sede);
                            } else {
                                s = obj.sede
                            }
                            return s[key.replace('sede.', '')]
                        } catch(e) {
                            return "";
                        }
                    }
                }

                if (key == 'current_user') {
                    let user = localStorage.getItem('signature');

                    let user_id = localStorage.getItem('user_id');

                    if (user_id == obj['user_id']) {
                        user = user.split('@');
                        return user[0];
                    } else {
                        try {
                            let users = JSON.parse(localStorage.getItem('users'));
                            let u = users.filter((uf) => {
                                return uf.id == obj['user_id']
                            });
                            if (u && u.length > 0) {
                                return u[0].name;
                            }
                        } catch (e) {
                            return "";
                        }

                    }
                }

                key = key.replace(/\[(\w+)\]/g, '.$1');
                key = key.replace(/^\./, '');

                // cagatissima temporanea
                if(key == "d3.a1") key = 'd3_a1';
                if(key == "d3.a2") key = 'd3_a2';
                if(key == "d3.a3") key = 'd3_a3';
                if(key == "d3.b1") key = 'd3_b1';
                if(key == "d3.b2") key = 'd3_b2';
                if(key == "d3.b3") key = 'd3_b3';
                if(key == "d3.b4") key = 'd3_b4';
                if(key == "d3.b5") key = 'd3_b5';
                if(key == "d3.b6") key = 'd3_b6';

                var a = key.split('.');

                for (var i = 0, n = a.length; i < n; ++i) {
                    var k = a[i];
                    if (k in obj) {
                        typ = typ || 'string';
                        if (typ == 'date') {
                            let d = moment(obj[k]);
                            if (d.isValid())
                                obj = d.format('DD/MM/YYYY');
                            else
                                obj = '';
                        } else {
                            obj = obj[k];
                        }
                    } else {
                        return;
                    }
                }
                return obj;
            },
            getDataUri(url, callback) {
                var image = new Image();
                image.onload = function () {
                    var canvas = document.createElement('canvas');
                    canvas.width = this.naturalWidth;
                    canvas.height = this.naturalHeight;
                    canvas.getContext('2d').drawImage(this, 0, 0);
                    callback(canvas.toDataURL('image/png'));
                };
                image.src = url;
            },
            generateNewUUID() {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
            },
            clearAllData(callback) {
                localForage.clear(callback)
            }
        };
        Vue.prototype.helpers = helpers;
    }
}
